<template>
  <div class="app-checkbox">
    <input
      type="checkbox"
      :id="id"
      @change="$emit('toggle-check', id)"
      :value="value"
      :checked="checked"
    />
    <label :for="id">{{ label }}</label>
  </div>
</template>

<script>
export default {
  emits: ["toggle-check"],
  props: {
    id: {
      type: Number || String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style lang="scss">
.app-checkbox {
  position: relative;
  cursor: pointer;

  input {
    position: absolute;
    top: 0;
    left: 0;
  }

  label {
    cursor: pointer;
    position: relative;
    transition: all 0.2s;
    font-weight: 700;
    display: flex;
    text-align: left;
    align-items: center;

    &::before {
      flex-shrink: 0;
      content: "";
      position: static;
      width: 15px;
      height: 15px;
      border-radius: 4px;
      background-color: #fff;
      margin-right: 8px;
      box-shadow: inset 0 0 0 1px $text;
    }

    &:hover {
      color: $accent-1;

      &::before {
        box-shadow: inset 0 0 0 1px $accent-1;
      }
    }
  }

  input {
    z-index: 1;
    opacity: 0;
  }

  input:checked + label {
    color: $accent-1;

    &::before {
      background-color: $accent-1;
      border: none;
      box-shadow: inset 0 0 0 1px $accent-1;
    }
  }
}
</style>
